(function () {
  'use strict';

  angular.module('app').component('costsAndPricesPage', costsAndPricesComponent());

  function costsAndPricesComponent() {
    return {
      bindings: {},
      controller: CostsAndPricesCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/costs-and-prices/costs-and-prices-page.component.html',
    };
  }

  CostsAndPricesCtrl.$inject = ['LanguageService'];

  function CostsAndPricesCtrl(LanguageService) {
    let vm = this;

    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;
      });
    }
  }
})();
